import { render, staticRenderFns } from "./SpecialsListing.vue?vue&type=template&id=1c8608c4&"
import script from "./SpecialsListing.vue?vue&type=script&lang=js&"
export * from "./SpecialsListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports